import React from "react";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { DatevExportRow } from "./datevExportTypes";

interface DatevExportCellProps {
  row?: DatevExportRow;
  disabled: boolean; // future month
  busy: boolean; // a request for this cell is in flight
  locked?: boolean; // any generation in progress — block all generate actions
  onGenerate: () => void; // Generate / Regenerate / Retry all POST generate
  onDownload: () => void;
}

const DatevExportCell: React.FC<DatevExportCellProps> = ({ row, disabled, busy, locked = false, onGenerate, onDownload }) => {
  if (disabled) {
    return <span className="text-color-secondary">—</span>;
  }
  if (!row) {
    return <Button label="Generate" size="small" loading={busy} disabled={locked} onClick={onGenerate} />;
  }
  if (row.status === "GENERATING") {
    const total = row.totalCount ?? 0;
    const done = total - (row.remainingCount ?? 0);
    return (
      <span className="inline-flex align-items-center gap-2 text-color-secondary">
        <ProgressSpinner style={{ width: "1rem", height: "1rem" }} strokeWidth="6" />
        Generating… {done}/{total}
      </span>
    );
  }
  if (row.status === "FAILED") {
    return (
      <Button label="Retry" icon="pi pi-exclamation-triangle" size="small" severity="warning" loading={busy} disabled={locked} onClick={onGenerate} />
    );
  }
  // READY
  const missing = row.missingCount ?? 0;
  return (
    <span className="inline-flex align-items-center gap-1">
      <Button icon="pi pi-download" label="Download" size="small" loading={busy} onClick={onDownload} />
      {missing > 0 && (
        <span className="text-orange-500 text-sm white-space-nowrap" title="Some receipts could not be fetched">
          ⚠ {missing} missing
        </span>
      )}
      <Button icon="pi pi-refresh" rounded text size="small" aria-label="Regenerate" disabled={locked || busy} onClick={onGenerate} />
    </span>
  );
};

export default DatevExportCell;
